import { createSelector } from "reselect";
import { isDefined } from "@grandvisionhq/utils";
import * as selectors_internal from "./selectors.internal.js";
import { getConfigurator as getConfigurator$1, getStepSequence, getCurrentStepNumber, getStepsVisited, getStepsList } from "./selectors.internal.js";
const { configuratorIdProp, stateProp, stepNameProp } = selectors_internal;
const getConfigurator = createSelector(
  configuratorIdProp,
  stateProp,
  (id, s) => getConfigurator$1(s, { id })
);
const hasAttemptedNextStep = createSelector(
  getConfigurator,
  (c) => c ? c.stepsAttempted.has(c.currentStep) : false
);
const getCurrentStep = createSelector(
  getStepSequence,
  getCurrentStepNumber,
  configuratorIdProp,
  stateProp,
  (stepSequence, currentStep) => {
    if (!isDefined(stepSequence) || !isDefined(currentStep)) {
      return;
    }
    return {
      name: stepSequence[currentStep] ?? ""
    };
  }
);
const hasVisitedStep = createSelector(
  getStepsVisited,
  configuratorIdProp,
  stepNameProp,
  (stepsVisited, id, stepName) => (stepsVisited || []).includes(stepName)
);
const isFooterOpen = createSelector(getConfigurator, (c) => c?.isFooterOpen ?? false);
const isLastStep = createSelector(getStepsList, (steps) => {
  if (!steps) {
    return false;
  }
  const lastStepIsCurrentStep = steps[steps.length - 1]?.isCurrent;
  if (!isDefined(lastStepIsCurrentStep)) {
    return false;
  }
  if (lastStepIsCurrentStep) {
    return true;
  }
  const currentStep = steps.findIndex((s) => s.isCurrent);
  const remainingSteps = steps.slice(currentStep + 1);
  return remainingSteps.every((s) => s.skip);
});
const getFinishCall = createSelector(getConfigurator, (c) => c?.calls.finish);
export {
  getConfigurator,
  getCurrentStep,
  getFinishCall,
  hasAttemptedNextStep,
  hasVisitedStep,
  isFooterOpen,
  isLastStep
};
//# sourceMappingURL=selectors.js.map
